// Maps status / category strings to tailwind chip classes (bg 15% + text)
const MAP = {
  // campaign statuses
  Idea: "bg-slate-500/15 text-slate-300",
  Draft: "bg-slate-500/15 text-slate-300",
  Planning: "bg-blue-500/15 text-blue-400",
  "Awaiting approval": "bg-yellow-500/15 text-yellow-400",
  Approved: "bg-teal-500/15 text-teal-400",
  Scheduled: "bg-blue-500/15 text-blue-400",
  Live: "bg-lime-500/15 text-lime-400",
  Paused: "bg-orange-500/15 text-orange-400",
  Completed: "bg-violet-500/15 text-violet-300",
  Cancelled: "bg-pink-500/15 text-pink-400",
  Archived: "bg-slate-500/15 text-slate-400",
  // task
  "To do": "bg-slate-500/15 text-slate-300",
  "In progress": "bg-blue-500/15 text-blue-400",
  Submitted: "bg-teal-500/15 text-teal-400",
  "Under review": "bg-yellow-500/15 text-yellow-400",
  "Changes requested": "bg-orange-500/15 text-orange-400",
  Published: "bg-lime-500/15 text-lime-400",
  Blocked: "bg-pink-500/15 text-pink-400",
  // approvals
  Pending: "bg-yellow-500/15 text-yellow-400",
  Rejected: "bg-pink-500/15 text-pink-400",
  "Changes requested ": "bg-orange-500/15 text-orange-400",
  // generic
  Active: "bg-lime-500/15 text-lime-400",
  Sent: "bg-lime-500/15 text-lime-400",
  Expired: "bg-slate-500/15 text-slate-400",
  "On track": "bg-lime-500/15 text-lime-400",
  "At risk": "bg-yellow-500/15 text-yellow-400",
  Confirmed: "bg-teal-500/15 text-teal-400",
  Planned: "bg-blue-500/15 text-blue-400",
  Shooting: "bg-violet-500/15 text-violet-300",
  Retouching: "bg-yellow-500/15 text-yellow-400",
  Delivered: "bg-lime-500/15 text-lime-400",
  Review: "bg-yellow-500/15 text-yellow-400",
  Positive: "bg-lime-500/15 text-lime-400",
  Neutral: "bg-slate-500/15 text-slate-300",
  Pitched: "bg-blue-500/15 text-blue-400",
};

export function statusClass(status) {
  return MAP[status] || "bg-violet-500/15 text-violet-300";
}

export const PRIORITY = {
  High: "bg-pink-500/15 text-pink-400",
  Medium: "bg-yellow-500/15 text-yellow-400",
  Low: "bg-blue-500/15 text-blue-400",
};

export const ACCENTS = ["#7C3AED", "#EC4899", "#3B82F6", "#2DD4BF", "#A3E635", "#FB7185", "#FACC15"];
